import { render, staticRenderFns } from "./UserManagementEditButton.vue?vue&type=template&id=ff3b546a&"
import script from "./UserManagementEditButton.vue?vue&type=script&lang=ts&"
export * from "./UserManagementEditButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports